import {
  DESCRICAO_PAGAMENTO_MAX_LENGTH,
  OBSERVACAO_MAX_LENGTH,
  type SolicitacaoPagamentoFormValues,
} from "@/services/solicitacaoPagamento";
import { validateDadosPagamento } from "./pagamentoMetodoUtils";

export type WizardStep = 1 | 2 | 3;

export const WIZARD_STEPS: Array<{ step: WizardStep; label: string }> = [
  { step: 1, label: "Login" },
  { step: 2, label: "Dados" },
  { step: 3, label: "Dados para pagamento" },
];

export function parseValorInput(raw: string): number | null {
  const s = raw.trim();
  if (!s) return null;
  const normalized = s.replace(/\./g, "").replace(",", ".");
  const n = Number(normalized);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.round(n * 100) / 100;
}

export function validateStep(
  step: WizardStep,
  values: SolicitacaoPagamentoFormValues,
): Record<string, string> {
  const errors: Record<string, string> = {};

  if (step === 1) {
    if (!values.aprovadorId) errors.aprovadorId = "Selecione quem irá aprovar.";
    else if (
      values.solicitanteId &&
      values.aprovadorId === values.solicitanteId
    ) {
      errors.aprovadorId = "Você não pode aprovar sua própria solicitação.";
    }
  }

  if (step === 2) {
    if (!values.costCenterId) errors.costCenterId = "Selecione o centro de custo.";
    if (!values.paymentCategoryId) errors.paymentCategoryId = "Selecione o plano financeiro.";
    if (!values.creditorId) errors.creditorId = "Selecione o fornecedor.";
    if (!values.descricao.trim()) errors.descricao = "Informe a descrição do pagamento.";
    else if (values.descricao.length > DESCRICAO_PAGAMENTO_MAX_LENGTH) {
      errors.descricao = `A descrição deve ter no máximo ${DESCRICAO_PAGAMENTO_MAX_LENGTH} caracteres.`;
    }
    if (values.observacao.length > OBSERVACAO_MAX_LENGTH) {
      errors.observacao = `A observação deve ter no máximo ${OBSERVACAO_MAX_LENGTH} caracteres.`;
    }
    if (parseValorInput(values.valor) == null) errors.valor = "Informe um valor válido.";
  }

  if (step === 3) {
    if (!values.formaPagamento) errors.formaPagamento = "Selecione a forma de pagamento.";
    if (!values.dueDate || values.dueDate.length < 10) {
      errors.dueDate = "Informe a data de vencimento.";
    }
    Object.assign(errors, validateDadosPagamento(values));
  }

  return errors;
}

export function validateAll(values: SolicitacaoPagamentoFormValues): Record<string, string> {
  return {
    ...validateStep(1, values),
    ...validateStep(2, values),
    ...validateStep(3, values),
  };
}
